import Vue from "vue";
import IExportService from "@/services/IExportService";
import Export from "@/models/export/Export";

export default class AxiosExportService implements IExportService {

	public export(model: Export): Promise<any> {
		return Vue.$axios.post('/export/report', {
			"genders": model.genders,
			"countryCodes": model.countryCodes,
			"employmentTypes": model.employmentTypes,
			"orderIds": model.orderIds,
			"states": model.reportStates,
			"amountFrom": model.amountFrom,
			"amountTo": model.amountTo,
			"dateFrom": model.dateFrom,
			"dateTo": model.dateTo

		}, {
			responseType: 'blob'
		}).then(res => res);
	}

}
